// src/pages/Payroll/ExportPayrollExcel.js
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import i18n from "../../../../i18n";
const ExportPayrollExcel = async (data) => {
  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet("Payroll Records");

  const t = i18n.t.bind(i18n);
  worksheet.columns = [
    { header: t("payroll.tableHeaders.id"), key: "id", width: 10 },
    { header: t("payroll.tableHeaders.worker"), key: "workerName", width: 20 },
    { header: t("payroll.tableHeaders.type"), key: "type", width: 18 },
    { header: t("payroll.tableHeaders.amount"), key: "amount", width: 15 },
    { header: t("payroll.tableHeaders.paymentDate"), key: "paymentDate", width: 20 },
    { header: t("payroll.tableHeaders.proof"), key: "proof", width: 15 },
    { header: t("payroll.tableHeaders.status"), key: "status", width: 15 },
    { header: t("payroll.tableHeaders.comments"), key: "comments", width: 30 },
  ];

  worksheet.addRows(data);

  worksheet.getRow(1).eachCell((cell) => {
    cell.font = { bold: true, color: { argb: "FFFFFFFF" } };
    cell.fill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: "003149" },
    };
    cell.alignment = { vertical: "middle", horizontal: "center" };
    cell.border = {
      top: { style: "thin" },
      left: { style: "thin" },
      bottom: { style: "thin" },
      right: { style: "thin" },
    };
  });

  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });
  saveAs(blob, `Payroll_Records_${new Date().toISOString().slice(0, 10)}.xlsx`);
};

export default ExportPayrollExcel;
